{
    "common": {
        "billing": "Billing",
        "crewLead": "Crew Lead",
        "crewLead_union": "Driver",
        "crewLeads": "Crew Leads",
        "crewLeads_union": "Drivers",
        "crewLeadUpper": "CREW LEAD",
        "crewLeadUpper_union": "DRIVER",
        "save": "Save",
        "cancel": "Cancel",
        "delete": "Delete",
        "yesDelete": "Yes, delete",
        "deleting": "Deleting",
        "edit": "Edit",
        "close": "Close",
        "clear": "Clear",
        "remove": "Remove",
        "removing": "Removing",
        "loading": "Loading...",
        "yes": "Yes",
        "no": "No",
        "language": "Language",
        "languageNative": "Language",
        "english": "English",
        "spanish": "Spanish",
        "errorPrefix": "Error:",
        "add": "Add",
        "warning": "Warning",
        "backToHome": "Back to Home"
    },
    "auth": {
        "signIn": "Sign in",
        "signOut": "Sign out",
        "register": "Register",
        "username": "Username",
        "password": "Password",
        "rememberMe": "Remember me",
        "forgotPassword": "Forgot your password?",
        "checkingCredentials": "Checking credentials...",
        "signingIn": "Signing in...",
        "signInError": "There was a problem signing you in.",
        "manageAccount": "Manage account"
    },
    "nav": {
        "myCalendar": "My Calendar",
        "nonFlaggingTimesheet": "Non-Flagging Timesheet",
        "myTimesheets": "My Timesheets",
        "timeTracker": "Time Tracker",
        "languagePreference": "Language preference",
        "myWork": "My Work",
        "addTimesheet": "Add Timesheet",
        "jobCalendar": "Job Calendar",
        "logOut": "Log Out",
        "changeLanguage": "Change Language",
        "quickLinks": "Quick Links",
        "subscribeDispatchPlusNotifications": "Subscribe to Dispatch Plus Notifications",
        "unsubscribeDispatchPlusNotifications": "Unsubscribe from Dispatch Plus Notifications",
        "dispatchPlusNotificationSubscriptionSaved": "Notification preference saved",
        "dispatchPlusNotificationSubscriptionSaveError": "There was a problem saving your notification preference"
    },
    "calendar": {
        "allDay": "All day",
        "previous": "Back",
        "next": "Next",
        "today": "Today",
        "month": "Month",
        "week": "Week",
        "day": "Day",
        "agenda": "Agenda",
        "date": "Date",
        "time": "Time",
        "event": "Event",
        "noEventsInRange": "There are no events in this range.",
        "showMore_one": "+{{count}} more",
        "showMore_other": "+{{count}} more",
        "legendUnconfirmed": "Unconfirmed",
        "legendConfirmed": "Confirmed",
        "legendTimeRejected": "Time Rejected",
        "errorBoundary": "Calendar failed to render.",
        "eventTitleWithJob": " - {{title}}"
    },
    "timesheet": {
        "crewTimesheet": "Crew Timesheet",
        "backToMyTimesheets": "Back to My Timesheets",
        "gettingTimesheet": "Getting timesheet...",
        "noTimesheetData": "No timesheet data available.",
        "status": "Status",
        "submittedOn": "Submitted on {{when}}",
        "byUser": "by {{user}}",
        "notYetSubmitted": "Not yet submitted",
        "employee": "Employee",
        "date": "Date",
        "timesheetDetails": "Timesheet Details",
        "notesLabel": "Notes",
        "notAvailable": "N/A",
        "total": "Total",
        "employeeSignature": "Employee Signature",
        "noSignatureAvailable": "No signature available",
        "timesheetNumber": "Timesheet Number",
        "timesheets": "Timesheets",
        "gettingTimesheets": "Getting timesheets...",
        "noTimesheetsFound": "No timesheets found.",
        "newNonFlaggingTimesheet": "New Non-Flagging Timesheet",
        "newSelfDispatchTimesheet": "New Self-Dispatch Timesheet",
        "employeeTimesheet": "Employee Timesheet",
        "addTimesheet": "Add Timesheet",
        "resubmitTimesheet": "Resubmit Timesheet",
        "unsavedChangesPrompt": "You have unsaved changes, are you sure you want to leave?",
        "dateRequired": "Date is required.",
        "contract": "Contract",
        "charge": "Charge",
        "chargeRequired": "A charge is required.",
        "equipment": "Equipment",
        "equipmentRequired": "An equipment selection is required.",
        "units": "Units",
        "enterValue": "Enter value",
        "valueRequired": "Value is required and must be greater than zero.",
        "startTime": "Start Time",
        "startTimeRequired": "Start Time is required.",
        "endTime": "End Time",
        "endTimeRequired": "End Time is required.",
        "employeeSignaturePreview": "Employee Signature Preview",
        "confirmDelete": "Are you sure you want to delete this timesheet?",
        "notes": "Notes",
        "deletionNotesPlaceholder": "Enter notes regarding the deletion.",
        "timeEntryOverlap": "This time entry overlaps entries you've already added for this date.",
        "saved": "Timesheet saved.",
        "deleted": "Timesheet deleted.",
        "approvalPending": "Timesheet Approval Pending",
        "approved": "Timesheet Approved",
        "resetToSubmitted": "Timesheet Reset to Submitted",
        "rejected": "Timesheet rejected.",
        "restored": "Timesheet restored.",
        "errorApproving": "Error Approving Timesheet",
        "errorRestoring": "Error in Restoring Timesheet: {{error}}",
        "errorSoftDeleting": "Error Soft Deleting Timesheet: {{error}}",
        "countyRequired": "A county selection is required for this timesheet",
        "correctErrors": "Please correct the highlighted errors.",
        "invalidTimeRange": "Please enter a valid time range.",
        "contactSaved": "Contact saved.",
        "contactSaveError": "Server Error when saving Contact.",
        "attachmentsUpdated": "Attachments updated successfully",
        "attachmentsUpdateFailed": "Failed to update attachments",
        "attachmentDeleted": "Attachment deleted",
        "attachmentDeleteFailed": "Failed to delete attachment",
        "rejectMissingBilling": "Unable to reject: missing billing record.",
        "rejectAlreadyInvoiced": "This timesheet has already been invoiced and cannot be rejected.",
        "rejectAlreadyApproved": "An admin needs to reject this timesheet due to it being approved already",
        "billingChargesRejected": "Billing: Charges Rejected",
        "jobDetails": "Job Details",
        "jobDetailsWithName": "Job Details - {{name}}",
        "backToCalendar": "Back to Calendar",
        "rejectionHistoryHeader": "Timesheet Rejection",
        "rejectionDate": "Date",
        "rejectedBy": "Rejected By",
        "rejectionNotes": "Notes",
        "meetingLocation": "Meeting Location",
        "jobLocation": "Job Location",
        "county": "County",
        "timesheetAttachments": "Timesheet Attachments",
        "uploadFiles": "Upload Files",
        "timesheetHeader": "TIMESHEET",
        "clientSig": "Client Sig",
        "crewSig": "Crew Sig",
        "dateStart": "Date/Start",
        "customer": "Customer",
        "dispatch": "Dispatch",
        "contractLabel": "Contract",
        "jobLabel": "Job",
        "foreman": "Foreman",
        "requestor": "Requestor",
        "openInGoogleMaps": "Open in Google Maps",
        "editTimesheet": "Edit Timesheet",
        "addOptionalCharge": "Add Optional Charge",
        "jobLocationOverride": "Job Location Override",
        "meetingLocationOverride": "Meeting Location Override",
        "addressNotGeocoded": "Address is not geocoded. Click Edit to enter a verifiable address.",
        "optional": "(Optional)",
        "requiredPlaceholder": "(Required)",
        "workTruckDaily": "Work Truck - Daily",
        "truck": "Truck",
        "flagging": "Flagging",
        "lunchBreakFlagging": "Lunch Break (Flagging)",
        "notesOptional": "(Optional, limit 2000 characters)",
        "paintBatchCode": "Paint Batch Code",
        "paintBatchCodePlaceholder": "ex: W-123 (separate codes with a comma)",
        "paintBatchCodeTooLong": "A paint batch code can be at most {{max}} characters.",
        "paintBatchCodesLimitReached": "Up to {{max}} paint batch codes can be recorded. Remove one before adding another.",
        "paintBatchPhotos": "Paint Batch Photos",
        "startUpper": "START",
        "stopUpper": "STOP",
        "addCharge": "Add Charge",
        "noEntriesAdded": "No entries added.",
        "time": "Time",
        "signatureColon": "Signature:",
        "signature": "Signature",
        "submitTimesheet": "Submit Timesheet",
        "timesheetCompleted": "This timesheet was completed.",
        "attachmentsWarning": "Are you sure you want to continue without file attachments?",
        "yesContinue": "Yes, continue",
        "statusNew": "New",
        "statusClientReview": "Client Review",
        "statusSubmitted": "Submitted",
        "statusRejected": "Rejected",
        "statusCancelPending": "Cancel Pending",
        "statusApprovalPending": "Approval Pending",
        "statusApproved": "Approved",
        "statusExported": "Exported",
        "statusDeleted": "Deleted",
        "statusOperationsReview": "Operations Review",
        "operationsReviewNotice": "NOTICE: This timesheet is under review by Operations and cannot be edited or resubmitted.",
        "editTime": "Edit Time",
        "addTime": "Add Time",
        "saveTimeEntry": "Save Time Entry",
        "deleteTimeEntry": "Delete Time Entry",
        "pleaseSelectDate": "Please select a date.",
        "durationFormat": "{{hours}}h {{minutes}}m",
        "approvedOn": "Approved on {{when}}",
        "rejectedBy": "Rejected by",
        "rejectionReasonOn": "{{reason}} on {{when}}",
        "noSetupForRoute": "The Administrator has not yet performed setup for this route. Please contact your supervisor or administrator.",
        "nonFlagContractNotCreated": "Non-Flagging Contract Not Created",
        "selfDispatchContractNotCreated": "Self-Dispatching Contracts Not Created",
        "nonFlagSetupNotComplete": "The Administrator has not yet performed setup for Non-Flagging timesheets. Please wait until this task is complete before trying to enter Non-Flagging time in the system.",
        "linkedTimesheetNote": "NOTE: This action adds another timesheet to the job and should only be used if more than one timesheet is needed. For example: If you need to submit separate timesheets for different customer work orders. If you do NOT need an additional timesheet, please select \"Cancel\" and complete any existing timesheets.",
        "adjBadge": "ADJ",
        "nfBadge": "NF",
        "notesUpper": "NOTES",
        "deleteTimesheet": "Delete Timesheet",
        "loadingEquipment": "Loading equipment...",
        "submitPreJobForm": "Submit Pre-Job Form",
        "preJobNotSubmitted": "Pre-Job form is not submitted.",
        "viewEditPreJobForm": "View/Edit Pre-Job Form",
        "timesheetSubmittedHeader": "Timesheet Submitted",
        "timesheetSubmittedBody": "This timesheet has been submitted.",
        "timesheetIncompleteHeader": "Timesheet Incomplete",
        "timesheetIncompleteBody": "Ensure all timesheet records are filled out and submitted.",
        "timesheetTitleParts": "{{customer}}{{subcontractorPart}} - {{jobNumber}}",
        "subcontractorPart": " - {{name}}",
        "woNumberPrefix": "WO #:",
        "timesheetDeletedNotice": "This timesheet has been deleted and cannot be modified.",
        "previousStepsIncompleteHeader": "Previous Steps Incomplete",
        "previousStepsIncompleteBody": "Ensure the timesheet is filled out and submitted prior to client review.",
        "preJobIncompletePrompt": "Pre-Job Form is incomplete. Would you like to continue with timesheet submission?",
        "qty": "Qty",
        "maximumWithValue": "(Maximum: {{max}})",
        "estimatedTravelTime": "Estimated travel time:",
        "sameForAll": "Same For All?",
        "workOrderHashLabel": "Work Order #",
        "submissionInvalid": "Your submission contains invalid entries.",
        "addressMustBeGeocoded": "Address must be geocoded. Please enter a complete address with street, city, and state so it can be verified.",
        "minimumOneSetupCharge": "Timesheet must have at least one setup charge.",
        "errorSaving": "Error saving timesheet.",
        "errorSavingHeader": "There was a problem saving",
        "errorSavingUnexpectedHeader": "Unexpected problem saving the timesheet",
        "errorDeletingUnexpectedHeader": "Unexpected problem deleting the timesheet",
        "fileAttachmentsRequired": "File Attachments Required",
        "sendSmsTo": "Send SMS to {{name}}",
        "confirmedTooltip": "Confirmed",
        "clickToConfirmTooltip": "Click to confirm",
        "reviewCompleteTooltip": "Complete",
        "reviewIncompleteTooltip": "Complete both the timesheet and Client Review in order to do the Crew Review.",
        "requestedPrefix": "Requested:",
        "employeeReviewSaveError": "We were unable to save your timesheet review.  Message from the server: {{error}}",
        "signatureRequired": "A signature is required.",
        "noSignatureReasonRequired": "Provide a reason there was no signature.",
        "noSignatureReasonSelectionRequired": "Reason for no signature - a selection is required in the drop down.",
        "workCardRequired": "A work card is required.",
        "jobTypeSelectionRequired": "A job type selection is required.",
        "explanationRequired": "You must provide an explanation",
        "requiredQuestionsMissing": "Some required questions are missing an answer",
        "crewReviewSignatureTitle": "Crew Review / Signature",
        "employeeLabel": "Employee",
        "workOrder": "Work Order",
        "workTypeQuestion": "What type of work did you do today?",
        "driverAgreement": "Driver Agreement",
        "driverAgreementText": "As the Driver, I was directed by dispatch/manager to provide my partner with a ride to/from work today.",
        "wasProjectCompletedLabel": "Was the project completed on this timesheet?",
        "signatureType": "Type",
        "signatureTypeRequired": "An employee signature type is required.",
        "employeeSignatureLabel": "Employee Signature:",
        "signaturePreview": "Signature Preview",
        "uploadWorkCard": "Upload Work Card",
        "workCardAlt": "Work Card",
        "workCardRequiredForTimesheet": "Work card is required for this timesheet.",
        "earlyDepartureLeftEarlyLabel": "Employee left before being released?",
        "earlyDepartureDurationLabel": "How early did the employee leave?",
        "earlyDepartureDurationRequired": "Early departure duration is required when the employee left before being released.",
        "reuseSignatureLabel": "[Admin] Re-Use Signature",
        "driverNonFlaggingNotice": "Driver, please complete a non-flagging drive time timesheet to capture time spent picking up and dropping off partner to/from jobsite.",
        "workOrderBracketed": "[{{number}}]",
        "invalidEmailAddress": "Please enter a single valid email address.",
        "resetClientSignatureTitle": "Reset client signature",
        "resetClientSignatureBody": "Are you sure you want to reset the client signature? The client will need to re-sign the document.",
        "resetClientSignatureSaveLabel": "Reset",
        "resetClientSignatureSavingLabel": "Resetting...",
        "clientSignatureResetSuccess": "Client signature reset. The client will need to sign again.",
        "clientSignatureResetError": "Failed to reset client signature.",
        "clientSignatureResetErrorForApprovedTimesheet": "Timesheet has already been approved.",
        "clientReviewSignatureRequired": "A signature is required.",
        "clientReviewNoSignatureReasonRequired": "Provide a reason there was no signature.",
        "clientReviewNoSignatureReasonSelectionRequired": "Reason for no signature - a selection is required in the drop down.",
        "summaryOfBillableCharges": "Summary of Billable Charges",
        "clientReviewSignatureTitle": "Client Review / Signature",
        "resetClientSignatureLabel": "Reset Client Signature",
        "missingSignatureReason": "Missing Signature Reason",
        "missingSignatureReasonRequired": "A reason is required.",
        "missingSignatureNotesPlaceholder": "Enter notes for why there is no signature.",
        "missingSignatureNotesRequired": "Notes are required",
        "signatureTypeColon": "Type:",
        "clientSignatureTypeRequired": "A client signature type is required.",
        "clientSignatureLabel": "Client Signature:",
        "timesheetAdded": "Timesheet added.",
        "timesheetAddError": "Error adding timesheet.",
        "purchaseOrderHashLabel": "Purchase Order #",
        "workRequestHashLabel": "Work Request #",
        "minimumChargeFromCancel": "Minimum charge type from cancellation",
        "removeChargeType": "Remove this charge type",
        "exceedsThreshold": "Hours Exceed Suggested Threshold",
        "toggleStartStopApplies": "Toggle whether or not start and stop time applies for this charge type.",
        "enterFieldNote": "Enter field note (required)",
        "enterValueLabel": "Enter value",
        "openInGoogleMapsTooltip": "Open in Google Maps",
        "jobAttachmentsLabel": "Job Attachments",
        "employeeConfirmed": "Employee confirmed",
        "equipmentConfirmed": "Equipment confirmed",
        "submitNewPreJobTooltip": "Click to submit new Pre-Job form.",
        "viewEditPreJobTooltip": "Click to view or edit the pre-job form.",
        "clientReviewDetails": "Client Review Details",
        "employeeReviewDetails": "Employee Review Details",
        "editTimeEntryTooltip": "Click to edit this time entry",
        "removeTimeEntryTooltip": "Click to remove this time entry"
    },
    "confirm": {
        "driverDisclaimerRequired": "Please agree to the driver disclaimer before submitting.",
        "loadFailed": "There was a problem retrieving the job assignment.",
        "jobDetails": "Job Details",
        "jobDetailsWithName": "Job Details - {{name}}",
        "notFound": "Unable to locate the requested resource.",
        "alertConfirmed": "This assignment has been confirmed.",
        "alertCancelled": "This assignment has been cancelled.",
        "alertCancelledAndConfirmed": "This assignment has been cancelled and confirmed.",
        "alertCancelledByCustomer": "This assignment has been cancelled by the customer.",
        "meetingLocation": "Meeting Location",
        "jobLocation": "Job Location",
        "county": "County",
        "jobAttachments": "Job Attachments",
        "driverDisclaimerLabel": "Driver Disclaimer",
        "driverDisclaimerText": "Employees are not required or expected to give rides to/from jobsites. Unless requested by the Company, it is voluntary and is not hours worked",
        "driverDisclaimerMustAgree": "You must agree to the disclaimer before proceeding.",
        "crewAndEquipment": "Crew And Equipment",
        "sendGroupSmsToCrew": "Send Group SMS to Crew",
        "dispatchedFrom": "(Dispatched From {{name}})",
        "quantitySuffix": "(Quantity: {{quantity}})",
        "assignedTo": "(Assigned to: {{name}})",
        "assignedToYouTooltip": "Assigned to you",
        "assignedToEquipment": "(Assigned to: {{type}} {{name}})",
        "dropoff": "Dropoff",
        "pickup": "Pickup",
        "dropoffWithQty": "Dropoff: {{quantity}}",
        "pickupWithQty": "Pickup: {{quantity}}",
        "officeWithNumber": "Office - {{number}}",
        "confirm": "Confirm",
        "confirmCancellation": "Confirm Cancellation",
        "goToTimesheet": "Go to Timesheet",
        "callOff": "Call Off",
        "callOffSubmitting": "Submitting",
        "callOffSubmitted": "Your call off has been submitted to dispatch.",
        "callOffSubmitFailed": "Unable to submit the call off. Please contact dispatch.",
        "callOffDisclaimerLoadFailed": "Unable to load the call off disclaimer.",
        "callOffAcknowledgeRequired": "Please acknowledge the disclaimer before submitting.",
        "callOffNotesLabel": "Notes (optional)",
        "callOffNotesPlaceholder": "Add any details for dispatch",
        "callOffAcknowledgement": "I understand and agree to the above.",
        "assignedEmployeeWithLead": "{{name}} ({{lead}})",
        "assignedEquipmentBase": "{{type}} : {{name}}",
        "assignedEquipmentWithQty": "{{type}} : {{name}} {{qtySuffix}}"
    },
    "tenant": {
        "supportedLanguages": "Supported Languages",
        "supportedLanguagesHelp": "Languages staff can choose from. English is required.",
        "supportedLanguagesSaved": "Supported languages updated.",
        "supportedLanguagesSaveError": "Could not update supported languages."
    },
    "employee": {
        "preferredLanguage": "Preferred Language",
        "preferredLanguageSaved": "Preferred language updated.",
        "preferredLanguageSaveError": "Could not update preferred language.",
        "noLinkedUser": "This employee has no linked user account.",
        "onCallAvailabilityLabel": "Available for last minute call in and emergency jobs",
        "onCallAvailabilitySaved": "On call availability updated",
        "onCallAvailabilitySaveError": "There was a problem updating your on call availability",
        "onCallRestrictedMessage": "Your ability to be on-call has been restricted due to refusing job offers. Reach out to your OM for more details."
    },
    "timeTracker": {
        "noJobsScheduled": "No Jobs Scheduled",
        "shiftCompleted": "Shift Completed",
        "startShift": "Start Shift",
        "endShift": "End Shift",
        "startJob": "Start Job",
        "endJob": "End Job",
        "currentShiftStarted": "Current Shift Started:",
        "shiftStarted": "Shift Started:",
        "shiftCompletedLabel": "Shift Completed:",
        "currentJob": "Current Job",
        "todaysJobs": "Today's Jobs",
        "startTimeLabel": "Start Time:",
        "overrideTime": "Override Time",
        "time": "Time",
        "timeRequired": "A time is required",
        "notes": "Notes",
        "noteRequired": "A note is required",
        "confirm": "Confirm",
        "confirming": "Confirming",
        "confirmStartShift": "Confirm Start Shift",
        "confirmEndShift": "Confirm End Shift",
        "confirmStartJob": "Confirm Start Job",
        "confirmEndJob": "Confirm End Job",
        "shiftStartedSuccess": "Shift started",
        "shiftEndedSuccess": "Shift ended",
        "jobStartedSuccess": "Job started",
        "jobEndedSuccess": "Job ended",
        "failedStartShift": "Failed to start shift",
        "failedEndShift": "Failed to end shift",
        "failedStartJob": "Failed to start job",
        "failedEndJob": "Failed to end job",
        "couldNotLoadJobs": "Could not load jobs data",
        "overrideTimeRequired": "Override Time Value is required",
        "notesRequired": "Notes are required",
        "noJobSelected": "No job selected",
        "noTime": "No time",
        "customerLabel": "Customer:",
        "workOrderLabel": "WO#:",
        "jobLocationLabel": "Job Location:",
        "meetingLocationLabel": "Meeting Location:",
        "jobStartedTooltip": "Job Started:",
        "jobCompletedTooltip": "Job Completed:",
        "jobStartBeforeShift": "Job start time {{eventTime}} cannot be earlier than shift start time ({{shiftStart}})",
        "jobEndBeforeStart": "Job end time {{eventTime}} cannot be earlier than job start time {{startTime}}",
        "shiftEndBeforeStart": "Shift end time {{eventTime}} cannot be earlier than shift start time {{shiftStart}}",
        "shiftEndBeforeLatestJobEnd": "Shift end time {{eventTime}} cannot be earlier than the latest job end time {{jobEnd}}",
        "shiftEndTooCloseToNextJob": "Cannot end shift at {{eventTime}} - next job starts at {{nextJob}} (must be at least 1 hour apart)",
        "shiftStartBeforePrevious": "Shift start time {{eventTime}} cannot be earlier than previous shift end time {{previousEnd}}"
    }
}